import React from 'react';

interface Props {
    tag?: string;
    className?: string;
    html?: string;
}

const SafeHtml = ({
    className,
    html = '',
    ...props
}: Props) => {
    return <div
        dangerouslySetInnerHTML={{ __html: html }}
        className={`safe-html ${className}`}
        {...props}
    />;
};

export default SafeHtml;
